import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { RoadmapApi } from '../../apis/roadmap-api';
import type { IGetListParams } from '../../types/index';
import type { RoadmapRepository } from '../../services/roadmap-repository';

@injectable()
export class RoadmapRepositoryImpl implements RoadmapRepository {
    constructor(
        @inject(RoadmapApi) private roadmapApi: RoadmapApi
    ) {
    }

    previewMeta(meta: any) {
        return this.roadmapApi.previewMeta(meta);
    }

    create(title: string, meta: any) {
        return this.roadmapApi.create(title, meta);
    }

    update(roadMapId: string, meta: any) {
        return this.roadmapApi.update(roadMapId, meta);
    }

    delete(roadMapId: string) {
        return this.roadmapApi.delete(roadMapId);
    }

    init() {
        return this.roadmapApi.init();
    }

    getList(params?: IGetListParams) {
        return this.roadmapApi.getList(params);
    }
}
